export default "__VITE_ASSET__CuSQQh4L__"